<style scoped>
.dropzone {
  border-style: dashed;
}

.hidden {
  display: none;
}
</style>

<template lang="pug">
div
  .row
    .col.s12.m6
      div(ref='photoSmall')
        p.center-align.no-margin-bottom.blue-text Your Thumbnail Photo
        p.center-align.no-margin-top 256x192
    .col.s12.m6
      div(ref='photoBig')
        p.center-align.no-margin-bottom.blue-text Your Banner Photo
        p.center-align.no-margin-top 1024x384
    .col.s12.mt-5.text-sm-right
      button.btn.hidden#onSave(dark class= "primary")
        | Save

  //- .row
    .input-field.col.s6
      input#mobile(type='text', placeholder='Your mobile number', v-model='mobileNumber')
      label.active(for='mobile') Mobile number
</template>
<script>
import Dropzone from './../js/dropzone'
require('./../assets/dropzone.min.css')
require('./../assets/basic.min.css')

Dropzone.autoDiscover = false

export default {
  data () {
    return {
      initialized: false,
      mobileNumber: null,
      showSaveBtn: false
    }
  },
  watch: {
    '$store.state.profile.supplier' () {
      this.initializeDz()
    }
  },
  mounted () {
    this.initializeDz()
  },
  computed: {
    user () {
      return this.$store.state.auth.user || {}
    }
  },
  methods: {
    initializeDz () {
      if (!this.$store.state.profile.supplier) {
        return
      }

      this.mobileNumber = this.$store.state.profile.supplier.contactNumber

      return this.$nextTick(() => {
        this.$store.dispatch('auth/getAccessToken').then((accessToken) => {
          const url = `${this.$config.API_URL}/suppliers/${this.$store.state.profile.supplier.code}/photos`

          const options = {
            url: url,
            method: 'post',
            headers: {
              authorization: `Bearer ${accessToken}`
            },
            acceptedFiles: 'image/jpeg,image/jpg,image/png',
            paramName: 'photos',
            maxFiles: 1,
            clickable: true,
            addRemoveLinks: true
            // autoProcessQueue: false,
          }

          // const checkSize = this.checkSize
          // const initProfile = this.initProfile

          this.$refs.photoSmall.className = 'dropzone'
          this.$refs.photoBig.className = 'dropzone'
          // eslint-disable-next-line
          const store = this.$store;
          // eslint-disable-next-line no-unused-vars
          const smallPhotoDz = new Dropzone(this.$refs.photoSmall, {
            ...options,
            resizeWidth: 256,
            autoProcessQueue: false,
            init (file, done) {
              var submitButton = document.querySelector('#onSave')
              const myDropzone = this
              submitButton.addEventListener('click', function () {
                myDropzone.processQueue()
              })
              myDropzone.on('addedfile', function (file) {
                submitButton.classList.remove('hidden')
              })

              myDropzone.on('complete', function (file) {
                submitButton.classList.add('hidden')
                store.dispatch('profile/setImage', {url: file.dataURL, size: 'small'})
                setTimeout(function () {
                  myDropzone.removeFile(file)
                }, 3000)
              })
            }
          })
          // eslint-disable-next-line
          const bigPhotoDz = new Dropzone(this.$refs.photoBig, {
            ...options,
            resizeWidth: 1024,
            autoProcessQueue: false,
            init (file, done) {
              var submitButton = document.querySelector('#onSave')
              const myDropzone = this
              submitButton.addEventListener('click', function () {
                myDropzone.processQueue()
              })
              myDropzone.on('addedfile', function (file) {
                submitButton.classList.remove('hidden')
              })

              myDropzone.on('complete', function (file) {
                submitButton.classList.add('hidden')
                store.dispatch('profile/setImage', {url: file.dataURL, size: 'big'})
                setTimeout(function () {
                  myDropzone.removeFile(file)
                }, 3000)
              })
            }
          })

          this.initialized = true
        })
      })
    },
    checkSize (reqWidth, reqHeight, file) {
      return new Promise((resolve, reject) => {
        var fr = new FileReader()
        fr.onload = function () {
          // file is loaded
          var img = new Image()
          img.onload = function () {
            // image is loaded; sizes are available
            if (img.width === reqWidth && img.height === reqHeight) {
              resolve()
            } else reject(new Error(`Size must be ${reqWidth}x${reqHeight}`))
          }
          img.src = fr.result // is the data URL because called with readAsDataURL
        }
        fr.readAsDataURL(file)
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/app-settings-general.vue